// src/admin/components/AdminCampRow.jsx
//
// A single camp rendered as a table row (desktop) with columns:
// Camp | Location | Dates | Status | Patients | Billing | Cost | Profit | Margin | Action
//
// On small screens the parent table becomes horizontally scrollable
// (see .admin-table-scroll in adminDashboard.css).

import React from 'react';
import { useNavigate } from 'react-router-dom';
import CampFinancialBadge from './CampFinancialBadge';
import { formatCurrency, formatPercentage, formatDateRange, formatNumber } from './adminFormatters';
import { getProfitClass, getMarginClass } from './adminHelpers';

export default function AdminCampRow({ camp }) {
  const navigate = useNavigate();

  const handleView = () => {
    navigate(`/dashboard/admin/camp/${camp.id ?? camp.camp_id}`);
  };

  return (
    <tr
      className="cursor-pointer border-t border-[#E2E8E8] transition-colors hover:bg-[#F5F7F8]"
      onClick={handleView}
    >
      <td className="whitespace-nowrap px-4 py-3">
        <span className="font-semibold text-[#172B2B]">
          Camp #{camp.id ?? camp.camp_id}
        </span>
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-[#172B2B]">
        {camp.location || camp.branch_name || '—'}
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-[#6B7C7C]">
        {formatDateRange(camp.start_date, camp.end_date)}
      </td>

      <td className="whitespace-nowrap px-4 py-3">
        <CampFinancialBadge status={camp.status} size="sm" />
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-right tabular-nums text-[#172B2B]">
        {formatNumber(camp.patient_count ?? camp.total_patients)}
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-right tabular-nums font-medium text-[#172B2B]">
        {formatCurrency(camp.billing_amount ?? camp.total_billing)}
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-right tabular-nums text-[#172B2B]">
        {formatCurrency(camp.company_cost)}
      </td>

      <td
        className={`whitespace-nowrap px-4 py-3 text-right tabular-nums font-semibold ${getProfitClass(
          camp.profit
        )}`}
      >
        {formatCurrency(camp.profit)}
      </td>

      <td
        className={`whitespace-nowrap px-4 py-3 text-right tabular-nums font-semibold ${getMarginClass(
          camp.margin_percentage
        )}`}
      >
        {formatPercentage(camp.margin_percentage)}
      </td>

      <td className="whitespace-nowrap px-4 py-3 text-right">
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleView();
          }}
          className="rounded-lg border border-[#E2E8E8] bg-white px-3 py-1.5 text-xs font-semibold text-[#0D8F8C] shadow-sm transition-colors hover:bg-[#E8F8F7]"
        >
          View
        </button>
      </td>
    </tr>
  );
}
